<template>
  <div>
    <AppHeader
      :actions="['exit']"
      text="FidMarques"
      inverse
    />
    <main>
      <p class="error">
        {{ error }}
        <br>
        Nous en avons été informés et allons la corriger dans les plus brefs délais.
      </p>
    </main>
  </div>
</template>

<script>
import AppHeader from '~/components/layout/Header'

export default {
  layout: 'errors',
  components: { AppHeader },

  props: {
    error: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.error {
  text-align: center;
  margin: 2rem;
}
</style>
